import React, { useEffect, useState } from "react"
import CartItemTile from "@/components/cart/CartItemTile"
import Button from "@/components/core/Button/Button"
import SocialShare from "@/components/cart/OrderSummary/SocialShare"
import { analyticEventData } from "@/components/cart/OrderSummary/cartContstants"
import { getTranslations } from "@/components/cart/localization"
import { isMobile } from "react-device-detect"
import { continueShippingUrl } from "@/constants/index"
import printIcon from "@/public/icons/print-grey.svg"
import { setAuthModalVisibility } from "@/store/features/authSlice"
import { useDispatch, useSelector } from "react-redux"
import { INSTALL_SERVICES } from "@/utils/constants"
import { pushAnalyticsObjToDataLayer } from "./analytics"
import AbandonedCarts from "@/components/cart/AbandonedCarts"
import { useTranslation } from "next-i18next"
import Tag from "../core/Tag"
import { selectCartState } from "@/store/features/cartSlice"
import { getCartCount } from "@/components/cart/utils"
import { removeCartItem, scrollToError } from "./cartHelper"
import trashIcon from "@/public/icons/trash-icon.svg"
import Checkbox from "@/components/core/Checkbox/Checkbox"
import { addRemoveProductFromCartAnalytics } from "@/components/cart/cartAnalytics"
import ConfirmationModal from "../core/ConfirmationModal/ConfirmationModal"

const CartItems = props => {
  const {
    dispatchCallback,
    cartItems,
    loading,
    cartId,
    cartKey = "",
    mode,
    showAlert,
    title,
    isMerge,
    onMerge,
    isAuth,
    username,
    checkoutMode,
    abandonedFlag,
    isIscUser,
    isAbandonedCart,
    handleAbandonedCarts,
    loadAbandonedCart,
    errors,
    currencySign,
    showBundleModal,
    handleSelection,
    setCartQtyLoad,
    setLoadingText,
    ...restProps
  } = props
  const { cart: activeCart = {} } = useSelector(selectCartState)
  const [count, setCount] = useState(0)
  const dispatch = useDispatch()
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const { t } = useTranslation("cart")
  const staticText = getTranslations(t)
  useEffect(() => {
    getCartCount(cartItems)
  }, [cartItems])

  let alertCount = 0
  cartItems?.forEach(item => {
    if (item.outOfStock || item.noShipping) alertCount++
  })

  const showAuthModal = () => {
    pushAnalyticsObjToDataLayer({
      eventAction: "cart:landing page:your cart is empty:sign in",
      eventName: "cart:landing page:your cart is empty:sign in",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "sign in",
      internalLinkPosition: "cart",
      internalLinkType: "cart:navigation",
      internalLinkZoneName: "cart:landing page:your cart is empty",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    })
    dispatch(setAuthModalVisibility({ show: true }))
  }
  const getEventInfo = () => {
    return JSON.stringify({
      eventAction: "cart:landing page:your cart is empty:continue shopping",
      eventName: "cart:landing page:your cart is empty:continue shopping",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: "continue shopping",
      internalLinkPosition: "cart",
      internalLinkType: "cart:navigation",
      internalLinkZoneName: "cart:landing page:your cart is empty",
      internalLinkURL:
        typeof window !== "undefined" &&
        window.location.origin + continueShippingUrl,
      clickInternalLinks: "true",
    })
  }

  const noPadding = Boolean(cartItems?.length)

  const handleCopyCartId = () => {
    navigator.clipboard
      .writeText(cartKey)
      .then(() => {
        props.showToast("Cart ID copied to clipboard")
      })
      .catch(err => {
        console.error(err)
        props.showToast("Not able to copy the Cart ID")
      })
  }
  const cartRecoveryStatusTag =
    isAbandonedCart &&
    activeCart.anonymousId === undefined &&
    activeCart.cartState === "active" ? (
      <div className="cart-recovery-status">
        <Tag text={staticText.notRecovered} />
      </div>
    ) : (
      <div className="cart-recovery-status">{null}</div>
    )

  const copyCartIdButton = isAbandonedCart ? (
    <div className="copy-cart-id">
      {" "}
      <Button
        label={staticText.copyCartId}
        size={"small"}
        className="gbh-data-layer copy-cart-id-btn"
        type="ghost"
        onClick={handleCopyCartId}
      />{" "}
    </div>
  ) : null

  const isValidLineItem = item => {
    return item.category !== INSTALL_SERVICES && !item.isBundleChildItem
  }

  const isAllSelected = () => {
    if (cartItems && cartItems.length) {
      for (const item of cartItems) {
        if (!item.isBundleChildItem && item.category !== "Install Services") {
          if (!item.isSelected) {
            return false
          }
        }
      }
      return true
    }
  }

  const selectableItemCount =
    cartItems?.reduce((acc, item) => {
      if (!item.isBundleChildItem && item.category !== "Install Services") {
        return acc + 1
      }
      return acc
    }, 0) || 0

  const selectedItemCount =
    cartItems?.reduce((acc, item) => {
      if (
        !item.isBundleChildItem &&
        item.category !== "Install Services" &&
        item.isSelected
      ) {
        return acc + 1
      }
      return acc
    }, 0) || 0

  const handleDeleteSelected = async () => {
    const data = cartItems.filter(item => item.isSelected)
    const updateDataLayer = () => {
      data.forEach(item => addRemoveProductFromCartAnalytics("cmp:click", item))
    }
    return removeCartItem(data, updateDataLayer, null)
  }

  const redirectToPage = e => {
    e.preventDefault()
    window.location.href = window.location.origin + continueShippingUrl
  }

  return (
    <div
      className={`${
        !noPadding && !isIscUser ? "no-padding" : ""
      } cart-landing__content`}
      data-testid="cartItemTile"
    >
      <div className="row no-gutters cart-items">
        <div className="col">
          <div className={`row no-gutters`}>
            <div
              className={
                (isIscUser && !abandonedFlag) || !isAuth || !isIscUser
                  ? "col-lg-12 col-sm-6 col-md-6 cart-header"
                  : "col-lg-12 col-sm-6 col-md-6 cart-header mb-0"
              }
            >
              {mode !== "share" && cartItems?.length ? (
                <>
                  <div
                    className="cart-items__title"
                    role="heading"
                    aria-level="1"
                    aria-label={`${staticText.yourCart} ${count} items`}
                    data-testid="cartItem-title"
                  >
                    {isAbandonedCart
                      ? staticText.customerCart
                      : staticText.yourCart}{" "}
                    ({cartItems?.length > 0 ? getCartCount(cartItems) : 0})
                  </div>
                  <div className="cart-items__header-info">
                    {isIscUser ? cartRecoveryStatusTag : null}
                    {cartKey ? (
                      <span
                        className={`share-cart-id ${
                          isIscUser ? "abandoned-cart-key" : ""
                        }`}
                      >
                        {staticText.yourSharedCartID(cartKey)}
                      </span>
                    ) : null}
                    <div className="cart-id-share">
                      <SocialShare
                        id="kf-order-summary"
                        dispatchCallback={dispatchCallback}
                        cartId={cartId}
                        analyticEventData={analyticEventData}
                        selectedItems={
                          cartItems
                            ?.filter(item => item.isSelected)
                            .map(item => item.sku) || []
                        }
                      />
                      <button
                        className={`cart-actions delete ${
                          !selectedItemCount ? "disabled" : ""
                        }`}
                        onClick={() => setShowConfirmationModal(true)}
                      >
                        <img src={trashIcon.src} alt="delete" />
                      </button>
                    </div>
                  </div>
                  {cartKey ? (
                    <p
                      className={`mobile-share-cart-id ${
                        isIscUser ? "abandoned-cart-key" : ""
                      }`}
                    >
                      {staticText.yourSharedCartID(cartKey)}
                    </p>
                  ) : null}
                </>
              ) : null}
              {mode === "share" && (
                <div
                  className="cart-items__title"
                  role="heading"
                  aria-level="1"
                  aria-label={`${title} ${count} items`}
                  data-testid="cartItem-title"
                >
                  {title} ({cartItems?.length > 0 ? getCartCount(cartItems) : 0}
                  )
                </div>
              )}
            </div>
            {/* {!isMobile && mode === "share" && (
              <div className="col-12 col-sm-6 col-md-6">
                <div className="cart-items__download-print d-none d-lg-flex">
                  <span role="link" tabIndex="0" onClick={() => window.print()}>
                    <img src={printIcon?.src} alt={staticText.print} />
                    {staticText.print}
                  </span>
                </div>
              </div>
            )} */}
          </div>
          {mode !== "share" && showAlert && (
            <div className="row no-gutters" id="alert-wrapper">
              <div className="cart-items__alert">
                <span
                  role="alert"
                  tabIndex="0"
                  className="cart-items__alert-title"
                >{`${staticText.alert}: `}</span>
                {staticText.updateCartForDeliveryAlert}
                <a
                  className="cart-items__alert-link"
                  onClick={() => scrollToError(true)}
                >
                  {staticText.reviewCart}
                </a>
              </div>
            </div>
          )}
          {mode === "share" && (
            <div className={`row no-gutters`}>
              <div className="col-12">
                <div className="order-summary ">
                  <Button
                    customClass="cart-items__checkout-btn"
                    label={
                      isMerge
                        ? staticText.mergeWithCart
                        : staticText.addToMyCart
                    }
                    flexible
                    type="black"
                    onClick={onMerge}
                  />
                </div>
              </div>
            </div>
          )}
          {isMobile && mode === "share" && (
            <div className="row cart-items__th--mobile no-gutters">
              <div className="col-12 col-sm-6 col-md-6 d-none d-sm-block"></div>
              <div className="col-12 col-sm-6 col-md-6">
                <div className="cart-items__download-print d-none d-lg-flex">
                  <span role="link" tabIndex="0" onClick={() => window.print()}>
                    <img src={printIcon?.src} alt={staticText.print} />
                    {staticText.print}
                  </span>
                </div>
              </div>
            </div>
          )}
          <div
            className={`row cart-items__th no-gutters ${
              cartItems?.length ? "cart-table-header" : ""
            }`}
          >
            {cartItems?.length ? (
              <div className="col-12 col-sm-6 col-md-6 d-sm-block px-0">
                <div className="text-left cart-items__td" aria-hidden="true">
                  <div className="td-wrap">
                    {mode !== "share" && (
                      <div className="select">
                        <Checkbox
                          onChange={e =>
                            handleSelection(null, e.target.checked)
                          }
                          checked={isAllSelected()}
                          value=""
                        />
                      </div>
                    )}
                    <section className="d-none d-sm-block">
                      {staticText.item}
                    </section>
                    {mode !== "share" && (
                      <span>
                        {selectedItemCount}/{selectableItemCount} items selected
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
            <div className="col-12 col-sm-6 col-md-6 align-self-end pr-0">
              {cartItems?.length ? (
                <div className="row mx-0 px-0 cart-items__td-container">
                  <div
                    className="col-5 d-none d-sm-block  cart-items__td cart-td-unit-price"
                    aria-hidden="true"
                  >
                    {staticText.itemPrice}
                  </div>
                  <div
                    className={`${
                      mode === "share" ? "col-2" : "col-3"
                    } d-none d-sm-block text-center cart-items__td px-0`}
                    aria-hidden="true"
                  >
                    {staticText.qty}
                  </div>
                  <div
                    className={`col-4
                  d-none d-sm-block text-right cart-items__td pr-0`}
                    aria-hidden="true"
                  >
                    {staticText.total}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {!cartItems?.length && !loading ? (
            <div
              className={
                (isIscUser && !abandonedFlag) || !isAuth || !isIscUser
                  ? "cart-items__no-items no-border"
                  : "cart-items__no-items no-border p-0"
              }
            >
              <>
                {!abandonedFlag ? (
                  <div className="cart-items__no-items-message text-center">
                    {`${username ? username + "," : ""}`}{" "}
                    {staticText.noItemsInCart?.toLowerCase()}
                  </div>
                ) : null}
                {isIscUser && !abandonedFlag ? (
                  <p className="isc-cart-message text-center">
                    {" "}
                    {staticText.iscUserLoadMessage}{" "}
                  </p>
                ) : null}
              </>
              {isIscUser && abandonedFlag ? (
                <AbandonedCarts
                  currencySign={currencySign}
                  staticTexts={staticText}
                  loadAbandonedCart={loadAbandonedCart}
                  onClick={() => {
                    handleAbandonedCarts(!abandonedFlag)
                  }}
                />
              ) : null}
              {!isAuth && !isIscUser ? (
                <p className="sing-in-cart-message text-center">
                  {" "}
                  {staticText.signInItemsPreviously}{" "}
                </p>
              ) : null}
              <section className="cart-items__no-items-links d-flex text-center">
                {!isAuth && !isIscUser ? (
                  <Button
                    label="Sign In"
                    className="gbh-data-layer sing-in-cart"
                    type="black"
                    role="button"
                    tabIndex={0}
                    onClick={() => showAuthModal()}
                  />
                ) : null}
                {!isIscUser && (
                  <Button
                    label={staticText.continueShopping}
                    className="gbh-data-layer"
                    type="ghost"
                    onClick={redirectToPage}
                    data-gbh-data-layer={getEventInfo()}
                    to={"#"}
                  />
                )}
                {isIscUser && !abandonedFlag ? (
                  <Button
                    label={staticText.abandonedCarts}
                    className="gbh-data-layer"
                    type="ghost"
                    role="button"
                    to={"#"}
                    onClick={() => {
                      handleAbandonedCarts(!abandonedFlag)
                    }}
                  />
                ) : null}
              </section>
            </div>
          ) : null}
          {cartItems?.map(
            item =>
              isValidLineItem(item) && (
                <CartItemTile
                  key={item.id}
                  i18n={staticText}
                  loading={loading}
                  {...props}
                  data={item}
                  dispatchCallback={dispatchCallback}
                  checkoutMode={mode === "share"}
                  cartItems={cartItems}
                  errors={errors}
                  showBundleModal={showBundleModal}
                  handleSelection={handleSelection}
                  setLoadingText={setLoadingText}
                />
              )
          )}
        </div>
      </div>
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        onConfirm={handleDeleteSelected}
        onCancel={() => {}}
        desc={
          isAllSelected()
            ? "Are you sure you want to delete your cart?"
            : "Are you sure you want to delete selected item(s) from the cart?"
        }
      />
    </div>
  )
}

export default CartItems
